// Copyright (c) MobiFactory. All rights reserved.
// This source code is the property of MobiFactory. It is exclusively available to customers who have a valid user license.
// See LICENSE.txt file in the project root for full license information.

import { backendApiUrl } from "../api/backend";
import ContactPreview from "../model/ContactPreview";
import oidcManager from "../authentication/oidcManager";

/**
 * Helper class for photo
 */
export default class PictureHelper {
  /**
   * Gets the contact photo uri
   * @param {object} contact - contact object
   * @returns {string|null} contact photo uri
   */
  static getContactPhotoUri(contact: ContactPreview): string | null {
    if (contact) {
      const tenantId = oidcManager.userProfile.tid;
      return `${backendApiUrl()}/contactdetails/${contact.id}/photo/${tenantId}/${contact.fileName}`;
    }
    return null;
  }
}
